module.exports = __webpack_public_path__ + "static/img/card-contact-email.7e948375.png";